import {AppConsts} from "cf/packages/abpVue/AppConsts";
import PageTable from "../../basicElement/table/PageTable.vue";

let store = {}; //服务器分页组件缓存

export default {
  name: "fpBPageTable",
  data() {
    return {
      pageDataSource: {},
      fetch: false,
      pageIndex: parseInt(
        this.filterDto.page_number ? this.filterDto.page_number : 1
      ),
      pageSize: parseInt(
        this.filterDto.page_size ? this.filterDto.page_size : 10
      ),
      sort: this.filterDto.sorting,
      defaultSort: {}
    };
  },
  components: {
    PageTable
  },
  props: {
    cols: {
      type: Array,
      default: []
    },
    api: {
      type: String
    },
    server: {
      type: String,
      default: "/api/"
    },
    filterDto: {
      type: Object,
      default: {}
    },
    autoLoad: {
      type: Boolean,
      default: false
    },
    singleSelectTypeIcon: {
      type: String,
      default: "fa fa-edit"
    },
    selectType: {
      type: String
    },
    redirectUrl: {
      type: Boolean,
      default: false
    },
    singleSelectText: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "default"
    },
    keyPath: {
      default: "id"
    },
    totalRow: {
      type: Number,
      default: 0
    }
  },
  activated(){
    //组件重新激活（keepalive），强制刷新当前页面
    this.loadData(true);
  },
  methods: {
    handleSelect(args) {
      this.$emit("onSelect", args);
    },
    handleSingleSelect(args) {
      this.$emit("onSingleSelect", args);
    },
    handleCommandSelect(args) {
      this.$emit("onCommandSelect", args);
    },
    handleSort(e) {
      this.sort = e;
      this.loadData();
    },
    handlePage({currentPage, pageSize}) {
      this.pageIndex = currentPage;
      this.pageSize = pageSize;
      this.loadData();
    },
    refresh() {
      store = {};
      this.pageIndex = 1;
      this.loadData();
      this.$refs.table.handleClear();
    },
    update() {
      this.loadData();
    },
    loadData(force = false) {
      let size = this.pageSize || 10;

      var sortProp = "";
      var sortOrder = "";
      if (this.sort && this.sort.prop) {
        var col = this.cols.find(t => t.prop == this.sort.prop);
        sortProp = col.sortProp || col.prop;
        sortOrder = this.sort.order == "ascending" ? "asc" : "desc";
      } else {
        sortProp = this.defaultSort.prop;
        sortOrder = this.defaultSort.order == "ascending" ? "asc" : "desc";
      }

      var dto = Object.assign(
        {},
        {
          maxResultCount: size,
          skipCount: this.pageIndex == 1 ? 0 : (this.pageIndex - 1) * size
        },
        this.filterDto,
        {
          pageSort: {
            direction: sortOrder,
            sortProperty: sortProp
          }
        }
      );

      if (this.redirectUrl) {
        this.$router.push(this.$route.path);
        this.$router.push({
          path: this.$route.path,
          query: Object.assign({}, dto)
        });
      }

      var storeKey = JSON.stringify(dto);
      if (store[storeKey] && !force) {
        this.pageDataSource = store[storeKey];
        return;
      }
      this.fetch = true;
      this.http
        .request(this.api, dto)
        .then(ds => {
          this.pageDataSource = {
            totalRow: ds.page.totalElements,
            list: ds.page.content
          };
          store[storeKey] = this.pageDataSource;
          this.$emit("update:totalRow", this.pageDataSource.totalRow);
        })
        .finally(() => (this.fetch = false));
    }
  },
  mounted() {
    if (this.autoLoad) {
      this.update();
    }
    this.$emit("loaded");
  },
  created() {
    var defaultSortCol = this.cols.find(t => t.defaultSortOrder);

    if (defaultSortCol) {
      this.defaultSort = {
        prop: defaultSortCol.sortProp || defaultSortCol.prop,
        order: defaultSortCol.defaultSortOrder == "asc" ? "ascending" : "descending"
      };
    } else {
      this.defaultSort = {
        prop: "id",
        order: "descending"
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/businessElement/BPageTable/BPageTable.js